import CustomHttpAction from '../cardActions/CustomHttpAction';
import executeHttpAction from '../service/executeHttpAction';
import { Action, Input } from 'adaptivecards';

import { trace } from 'owa-trace';
import {
    CardDetails,
    ExecuteActionResponse,
    MessageContext,
    TelemetryProvider,
} from 'owa-actionable-message-v2';

export default function executeAction(
    action: Action,
    cardDetails: CardDetails,
    inputs: Input[],
    handleActionResponse: (response: ExecuteActionResponse) => void,
    messageContext: MessageContext,
    telemetryProvider: TelemetryProvider,
    isAutoInvokeAction: boolean
): boolean {
    if (action instanceof CustomHttpAction) {
        executeHttpAction(action, inputs, cardDetails, messageContext, isAutoInvokeAction).then(
            response => {
                trace.info(
                    '[ActionableMessageDebug] onExecuteAction: executeHttpAction response: ' +
                        response
                );
                handleActionResponse(response);
            }
        );
    } else {
        return false;
    }

    return true;
}
